import { Link } from 'wouter'
import { EmptyState } from '~/components/ui/empty.tsx'
import { useT } from '~/i18n/index.tsx'

export function NotFoundScreen() {
  const { t } = useT()
  return (
    <div className="mx-auto w-full max-w-[46rem] px-3 py-8 sm:px-4">
      <EmptyState
        title={t('empty.generic')}
        // The grid, not the filter form: from a dead URL the useful
        // destination is the thing that lists what exists.
        action={
          <Link href="/results" className="link-inline">
            {t('nav.results')}
          </Link>
        }
      >
        {location.pathname}
      </EmptyState>
    </div>
  )
}
